import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../html/element'

export const TextHover = ({ style, text, ...props }) => {
  const [onHover, setOnHover] = useState(false)

  const onMouseOver = () => {
    setOnHover(true)
  }

  const onMouseOut = () => {
    setOnHover(false)
  }

  return (
    <>
      <Element
        elementName="span"
        className="fw600 cursorPointer"
        style={{
          fontSize: onHover ? 16 : 12,
          color: '#2C73E8',
          ...style,
        }}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        {...props}
      >
        <Translate value={text} />
      </Element>
    </>
  )
}
